"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessPage = void 0;
const native_base_1 = require("native-base");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Breakpoints_1 = require("../../../../helper/Breakpoints");
const organisms_1 = require("../../../organisms");
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
function SuccessPage(props) {
    const { navigation, setCurrentPage } = props;
    const next = () => {
        navigation.navigate('Dashboard');
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: 1,
            },
        };
        setCurrentPage(reducerType);
    };
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(native_base_1.ScrollView, { bgColor: "#fff", h: "100%", w: "100%" },
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(native_base_1.VStack, { space: 5, alignItems: 'center', style: GlobalStyles_1.globalStyles.mobileToWebContainer },
                react_1.default.createElement(native_base_1.Center, { w: "100%", mt: "20" },
                    react_1.default.createElement(native_base_1.Text, { fontSize: "2xl", w: "80%", textAlign: "center", fontWeight: "bold", color: "#3db384" }, "Vielen Dank")),
                react_1.default.createElement(native_base_1.Center, { w: "100%", mt: "3" },
                    react_1.default.createElement(native_base_1.Text, null, "Ihr Folgerezeptantrag wurde erfolgreich abgeschickt.")),
                react_1.default.createElement(native_base_1.Button, { mt: "12", w: "40%", alignSelf: 'center', backgroundColor: '#3db384', borderRadius: "3xl", _text: { color: '#fff', fontWeight: 'bold' }, onPress: next }, "Zum Dashboard")))));
}
exports.SuccessPage = SuccessPage;
